import { Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IStepInit, Step } from "../interfaces";
import { LogClass, Logger } from "../logger";
import { selectCurrentUser } from "../user/state";

// https://dzone.com/articles/why-we-shound-not-use-function-inside-angular-temp

@Pipe({
    name: "canWorkStep",
    pure: true,
    standalone: false
})
@LogClass({ source: "CanWorkStepPipe" })
export class CanWorkStepPipe implements PipeTransform {
  private logger: Logger;

  constructor(private store: Store) {
    this.logger.debug("ctor");
  }

  public transform(value: Step | IStepInit): Observable<boolean> {
    if (!value) {
      return of(false);
    }

    if (value instanceof Step) {
      return this.store
        .select(selectCurrentUser)
        .pipe(switchMap((user) => value.canWork(user)));
    }

    const tmp = new Step(value);
    return this.transform(tmp);
  }
}
